import { ProductsPageProps } from './products-page.types'
import styles from './products-page.module.scss'
import cl from 'classnames'
import { PageContainer, PageHeader } from '@touche-lts/panel-ui/dist'
import { IconProducts } from 'assets/icons'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import { ProductsTable } from 'components'

const ProductsPageComponent = (props: ProductsPageProps) => {
  const { className, style } = props
  const {
    productsTableStore: {
      triggerSearch,
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      searchResults,
      paginationInfo,
      onPageSelect
    }
  } = useRootStore()

  useEffect(() => {
    triggerSearch()
  }, [triggerSearch])

  return (
    <PageContainer className={cl(styles.scrollable, className)} style={ {...style,  overflow : "hidden" }}>
      <PageHeader
        navSegments={[
          {
            icon: IconProducts,
            label: "Products",
          },
        ]}
      />
      <ProductsTable
        {...{
          triggerSearch,
          isColumnMarked,
          getSortDirection,
          handleSortDirectionChange,
          searchProps,
          onSearchPropsChange,
          searchResults,
          paginationInfo,
          onPageSelect,
        }}
      />
    </PageContainer>
  );
}

const ProductsPage = observer(ProductsPageComponent)
export { ProductsPage }
